module.exports = __webpack_public_path__ + "static/media/medtronics_logo.e669ee48.png";